import { View } from 'react-native';

export type CircularBarProps = {
    children: React.ReactNode;
    size?: number;
    circleRadius?: number;
    strokeColor?: string;
    strokeBackgroundColor?: string;
    strokeWidth?: number;
    percentage?: number;
};

// FIXME: This function is too large and should be broken up

export function CircularBar({
    children,
    size = 50,
    circleRadius = 20,
    strokeColor = '#484848',
    strokeBackgroundColor = '#00000040',
    strokeWidth = 5,
    percentage = 100,
}: CircularBarProps) {
    const radius = circleRadius;
    const circumference = 2 * Math.PI * radius;
    const arcLength = (percentage / 100) * circumference;

    return (
        <View style={[{ width: size, height: size }]}>
            <View style={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>{children}</View>
            <View style={{ position: 'absolute' }}>
                <svg height={size} viewBox={`0 0 ${size} ${size}`} width={size}>
                    <path
                        d={`
                            m ${size / 2},${size / 2 - radius}
                            a ${radius},${radius},0,0,0,0,${2 * radius}
                            a ${-radius},${-radius},0,0,0,0,${-2 * radius}
                            z
                        `}
                        fill='none'
                        stroke={strokeBackgroundColor}
                        strokeLinecap='butt'
                        strokeWidth={strokeWidth}
                    />
                    <path
                        d={`
                            m ${size / 2},${size / 2 - radius}
                            a ${radius},${radius},0,0,0,0,${2 * radius}
                            a ${-radius},${-radius},0,0,0,0,${-2 * radius}
                            z
                        `}
                        fill='none'
                        stroke={strokeColor}
                        strokeDasharray={`${arcLength}, ${circumference}`}
                        strokeLinecap='butt'
                        strokeWidth={strokeWidth}
                    />
                </svg>
            </View>
        </View>
    );
}
